angular.module('impactx.controlstructure').service('ControlRelationService', ControlRelationService);

function ControlRelationService() {

    function setControlDataToScope(scopeObject, relation) {
        scopeObject.readOnlyRelation = {assigned: relation.readOnly, available: []};
        scopeObject.assignedRelation = {assigned: relation.assigned, available: relation.available};
        scopeObject.deniedRelation = {assigned: relation.denied, available: relation.available};
    }

    function copyRelationDataToDTO(targetObject, sourceObject) {
        targetObject.assigned = sourceObject.assignedRelation.assigned;
        targetObject.denied = sourceObject.deniedRelation.assigned;
        if(targetObject.defaultControl && targetObject.defaultControl.selected) {
            targetObject.defaultControl.selected = JSON.parse(JSON.stringify(targetObject.defaultControl.selected));
            targetObject.defaultControl.selected.xOrder = undefined;
        }
    }

    return {
        setControlDataToScope: setControlDataToScope,
        copyRelationDataToDTO: copyRelationDataToDTO,
    };
}